import React from 'react'
import styled from 'styled-components'
import { HeroSection } from './components/herosection'
import { NavBar } from '../../components/navbar'
import { PopularCatSection } from './components/popularcategories'
import { RecentlyAdded } from './components/recentlyadded'
import { NewsPaperFeed } from './components/openaccess'
import { PopularNigeriana } from './components/popularnigeriana'
import { ExternalResources } from './components/externalresources'
import { Footer } from '../../components/footer'


const LandingPage = () => {
  return (
    <div>
      <Container>
      <NavBar />
      <HeroSection />
      <PopularCatSection />
      <RecentlyAdded />
      <ExternalResources tags />
      <PopularNigeriana />
      <NewsPaperFeed />
      <Footer />

      </Container>


    </div>
  )
}

const Container = styled.section`
  width: 100%;
  scroll-behavior: smooth;
`

export {LandingPage}